import request from "@/http/request"
import {
  getCoursePayList,
  coursePayImport,
  payCourseForOne,
  exportCoursePay,
} from '@/http/api'

export const getPayManagementList = (data) => {
  return request({
    url: getCoursePayList,
    data
  })
}

export const importPayFn = (data) => {
  return request({
    url: coursePayImport,
    isUpload: true,
    data
  })
}

export const payCourseForOneFn = (data) => {
  return request({
    url: payCourseForOne,
    data
  })
}

export const exportCoursePayFn = (data) => {
  return request({
    url: exportCoursePay,
    data
  })
}